import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { api } from "@/shared/api/client";
import { today } from "@/shared/lib/format";

/**
 * Tells ClientOS which page was opened (its pattern, /invoicing/invoices/$id, never what's on
 * it, on the company's day), for its product analytics. Nothing waits on it, and a failure
 * is let go.
 */
export function useReportPages() {
  const router = useRouter();
  useEffect(() => {
    let last = "";
    const report = () => {
      const page = router.state.matches.at(-1)?.fullPath;
      const here = router.state.location.href;
      if (!page || here === last) return;
      last = here;
      api.post("/v1/activity", { page, day: today() }).catch(() => {});
    };
    report();
    return router.subscribe("onResolved", report);
  }, [router]);
}
